export const getIconName = (path: string): string => {
  const [fileName] = path.split('/').reverse()[0].split('.');
  return fileName.charAt(0).toUpperCase() + fileName.slice(1);
};
